const identifierKeys = ['contractId', 'contract_id', 'contractKey', 'contract_key'];
const nameKeys = ['contractName', 'contract_name'];
const owns = (row, key) => Object.prototype.hasOwnProperty.call(row, key);

// CP에게는 내부 계약 오류를 노출하지 않는다. 명시적 null과 미제공은 구분한다.
export function transactionContractLabel(row) {
  if (!row || ![...identifierKeys, ...nameKeys].some((key) => owns(row, key))) return null;
  if (identifierKeys.some((key) => typeof row[key] === 'string' && row[key].trim().toUpperCase() === 'UNMAPPED')) return '-';
  if (identifierKeys.some((key) => owns(row, key) && row[key] === null)) return '-';
  const name = row.contractName ?? row.contract_name;
  if (typeof name !== 'string' || !name.trim() || name.trim() === '미분류') return '-';
  return name.trim();
}
